import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute({
  redirectTo = "/administracion/tienda/login",
}) {
  const token = localStorage.getItem("tienda_token");

  let usuario = null;
  try {
    usuario = JSON.parse(localStorage.getItem("tienda_data") || "null");
  } catch {
    usuario = null;
  }

  const isLogged = !!(token && usuario?.id);

  if (!isLogged) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}